const MAX_LINE_LENGTH = 34;

const PHRASE_BREAKS = [
  /(?<=에 맞춰)/,
  /(?<=에 따라)/,
  /(?<=기 때문에,)/,
  /(?<=했으며,)/,
  /(?<=하며,)/,
  /(?<=하고,)/,
  /(?<=하여,)/,
  /(?<=을 통해)/,
  /(?<=를 통해)/,
  /(?<=하도록)/,
  /(?<=도록)/,
  /(?<=로 )/,
];

function tryCommaSplit(sentence) {
  const commaParts = sentence.split(/(?<=,)\s+/);
  if (commaParts.length <= 1) return null;

  const lines = [];
  let buffer = "";

  for (const part of commaParts) {
    const candidate = buffer ? `${buffer} ${part}` : part;
    if (candidate.length <= MAX_LINE_LENGTH || !buffer) {
      buffer = candidate;
      continue;
    }
    lines.push(buffer.trim());
    buffer = part;
  }

  if (buffer) lines.push(buffer.trim());
  return lines;
}

function splitAtBalancedMiddle(sentence) {
  const target = Math.floor(sentence.length / 2);
  let bestSplit = null;

  for (let i = 0; i < sentence.length; i += 1) {
    const ch = sentence[i];
    if (ch !== " " && ch !== "·") continue;

    const left = sentence.slice(0, i).trim();
    const right = sentence.slice(i + 1).trim();
    if (left.length < 10 || right.length < 10) continue;

    const balance = Math.max(left.length, right.length);
    const distance = Math.abs(i - target);
    if (
      !bestSplit ||
      balance < bestSplit.balance ||
      (balance === bestSplit.balance && distance < bestSplit.distance)
    ) {
      bestSplit = { left, right, balance, distance };
    }
  }

  return bestSplit;
}

function findPhraseSplit(sentence) {
  let bestSplit = null;

  for (const pattern of PHRASE_BREAKS) {
    let searchFrom = 0;

    while (searchFrom < sentence.length) {
      const slice = sentence.slice(searchFrom);
      const match = slice.match(pattern);
      if (!match) break;

      const idx = searchFrom + match.index + match[0].length;
      const left = sentence.slice(0, idx).trim();
      const right = sentence.slice(idx).trim();

      if (left.length >= 10 && right.length >= 10) {
        const balance = Math.max(left.length, right.length);
        if (!bestSplit || balance < bestSplit.balance) {
          bestSplit = { left, right, balance };
        }
      }

      searchFrom = idx;
    }
  }

  return bestSplit;
}

function splitLongSentence(sentence) {
  if (sentence.length <= MAX_LINE_LENGTH) {
    return [sentence];
  }

  const commaLines = tryCommaSplit(sentence);
  if (commaLines) {
    return commaLines.flatMap((line) =>
      line.length > MAX_LINE_LENGTH ? splitLongSentence(line) : [line],
    );
  }

  const phraseSplit = findPhraseSplit(sentence);
  if (phraseSplit) {
    return [
      ...splitLongSentence(phraseSplit.left),
      ...splitLongSentence(phraseSplit.right),
    ];
  }

  const conjunctionMatch = sentence.match(/\s+(및|또는|그리고)\s+/);
  if (conjunctionMatch && conjunctionMatch.index > 12) {
    const idx = conjunctionMatch.index;
    return [
      ...splitLongSentence(sentence.slice(0, idx).trim()),
      ...splitLongSentence(sentence.slice(idx).trim()),
    ];
  }

  const middleSplit = splitAtBalancedMiddle(sentence);
  if (middleSplit) {
    return [
      ...splitLongSentence(middleSplit.left),
      ...splitLongSentence(middleSplit.right),
    ];
  }

  return [sentence];
}

/** Split portfolio copy into readable centered lines (sentence-first, then commas/phrases). */
export function formatParagraphLines(text) {
  if (!text?.trim()) return [""];

  const sentences = text
    .split(/(?<=[.!?。])\s+/)
    .map((sentence) => sentence.trim())
    .filter(Boolean);

  if (sentences.length === 0) return [text.trim()];

  return sentences.flatMap((sentence) => splitLongSentence(sentence));
}
